<div class="doi">
	<div class="row column">
		<h1><i class="twingle-heart"></i>{{ 'doi.headline' | translate }}</h1>
		<p class="teaser">{{ 'doi.teaser' | translate }}</p>
	</div>

	<!-- share -->
	<share [step]="step"></share>

	<div class="row column">
		<p class="footer">{{ 'doi.footer' | translate }}</p>
	</div>
</div>